var __templateData = Handlebars.template({"1":function(depth0,helpers,partials,data) {
  var helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return "  <div class=\"col-12\">\n    <button class=\"add-outcome btn btn-block\">\n      "
    + escapeExpression(((helpers.i18n || (depth0 && depth0.i18n) || helperMissing).call(depth0, "/es:outcome.add", {"name":"i18n","hash":{},"data":data})))
    + "\n    </button>\n  </div>\n";
},"3":function(depth0,helpers,partials,data) {
  var stack1, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, buffer = "  <div class=\"col-6\">\n    <button class=\"add-outcome btn btn-block\">\n      "
    + escapeExpression(((helpers.i18n || (depth0 && depth0.i18n) || helperMissing).call(depth0, "/es:outcome.add", {"name":"i18n","hash":{},"data":data})))
    + "\n    </button>\n  </div>\n  <div class=\"col-6\">\n    <button\n      class=\"import-outcome btn btn-block btn-import\"\n      title=\""
    + escapeExpression(((helpers.i18n || (depth0 && depth0.i18n) || helperMissing).call(depth0, "/import.outcomes_title", {"name":"i18n","hash":{},"data":data})))
    + "\"\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.importDisabled : depth0), {"name":"if","hash":{},"fn":this.program(4, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  return buffer + "\n    >\n      "
    + escapeExpression(((helpers.i18n || (depth0 && depth0.i18n) || helperMissing).call(depth0, "/import.outcomes", {"name":"i18n","hash":{},"data":data})))
    + "\n    </button>\n  </div>\n";
},"4":function(depth0,helpers,partials,data) {
  return "disabled";
  },"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, buffer = "<div class=\"outcome-buttons row mt-10\">\n";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.prognostic : depth0), {"name":"if","hash":{},"fn":this.program(1, data),"inverse":this.program(3, data),"data":data});
  if (stack1 != null) { buffer += stack1; }
  return buffer + "</div>\n";
},"useData":true});
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}